import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/insights`;

// Get uninvoiced bonliv for the specified period
export const fetchUninvoicedBonliv = (days = 7) => {
  return axios.get(`${API_URL}/uninvoiced-bonliv`, {
    params: { days }
  });
};

// Get dashboard summary stats
export const fetchDashboardSummary = () => {
  return axios.get(`${API_URL}/summary`);
};






